import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

const NonProratedReadingBar = ({ startPosition, endPosition, totalConsumption, prorationPosition, daysLeft }) => {
    const width = endPosition - startPosition;

    return (
        <Box
            sx={{
                position: 'absolute', // Üst üste bileşenleri konumlandırmak için
                left: `${startPosition}px`,
                width: `${width}px`,
                height: '30px',
            }}
        >
            {/* Gri Chip */}
            <Chip
                sx={{
                    position: 'absolute',
                    width: '100%',
                    backgroundColor: '#b0bec5', // Yumuşak gri renk
                    color: 'white',
                    zIndex: 1, // Geri planda olacak
                    display: 'flex',
                    justifyContent: 'flex-end', // Yazıyı sağa yaslamak için
                    paddingRight: '8px', // Sağ kenardan boşluk
                }}
                label={
                    <Typography 
                        variant="body2" 
                        sx={{
                            fontSize: '0.8rem',
                            width: '100%',
                            textAlign: 'right',
                        }}
                    >
                        {daysLeft} gün
                    </Typography>
                }
            />
            {/* Yeşil Chip */}
            <Chip
                sx={{
                    position: 'absolute',
                    width: `${prorationPosition - startPosition}px`,
                    backgroundColor: '#66bb6a', // Daha yumuşak yeşil renk
                    color: 'white',
                    zIndex: 2, // Önde olacak
                    display: 'flex',
                    justifyContent: 'center',
                }}
                label={
                    <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                        {totalConsumption} kWh (Tamamı)
                    </Typography>
                }
            />
        </Box>
    );
};

export default NonProratedReadingBar;
